import { createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkAppDispatch } from '../../../types/redux/utils/ThunkAppDispatch';
import { ThunkExtraArgs } from '../../../types/redux/utils/ThunkExtraArgs';
import { RootState } from '../../../types/redux/states/RootState';

export const createCustomAsyncThunk = createAsyncThunk.withTypes<{
  rootState: RootState;
  dispatch: ThunkAppDispatch;
  extra: ThunkExtraArgs;
}>();

// We have to do some magic because the type is not being exposed by RTK
type TType = Parameters<Parameters<typeof createCustomAsyncThunk>[1]>[1];
export interface ThunkAPIType extends TType {
  dispatch: ThunkAppDispatch;
  extra: ThunkExtraArgs;
}
